import React, { Component } from "react";
import Idea from "./Idea";
import mixitup from "mixitup";
import IdeaForm from "./IdeaForm";
import ideaService from "../services/ideaService.js";

class IdeasList extends Component {
  state = {
    ideas: [],
    receivedIdeas: [],
  };
  handleVote = async (idea) => {
    const ideas = [...this.state.ideas];
    const index = ideas.indexOf(idea);
    idea.totalVotes++;
    idea.userAlreadyVoted = true;
    ideas[index] = { ...idea };
    this.setState({ ideas });
    setTimeout(this.sortIdeas, 100);
    await ideaService.voteIdea(idea);
  };
  refresh = (newIdea) => {
    this.readIdeas();
  };
  componentDidMount() {
    this.readIdeas();
  }
  async readIdeas() {
    const { data: result } = await ideaService.getIdeas();
    this.setState({ receivedIdeas: result.ideas });
    this.filterIdeasByStatus("Under Consideration");
    //this.sortIdeas();
  }
  filterIdeasByStatus(status) {
    this.setState({
      ideas: this.state.receivedIdeas.filter((x) => x.status === status),
      filteredStatus: status,
    });
  }
  sortIdeas = () => {
    var mixer1 = mixitup(".ideas-list");
    mixer1.sort("order:desc");
    mixer1.destroy();
  };
  render() {
    return (
      <div className="ideas-list p-3">
        <h3>How can we improve Lanteria HR?</h3>
        <div>
          You are welcome to suggest improvements, request new features, or vote
          for the features suggested by other users. The top-rated suggestions
          will be included in the product roadmap. Your feedback is appreciated!
        </div>
        <div className="card-list-head p-1">
          <IdeaForm
            onSubmit={(idea) => this.refresh(idea)}
            mode="new"
          ></IdeaForm>
        </div>
        <div className="p-2">
          <a
            href="# "
            className={
              this.state.filteredStatus === "Under Consideration"
                ? "text-secondary"
                : "text-primary"
            }
            onClick={() => this.filterIdeasByStatus("Under Consideration")}
          >
            Under Consideration
          </a>
          <span className="badge badge-warning badge-module ml-1 mr-2">
            {
              this.state.receivedIdeas.filter(
                (x) => x.status === "Under Consideration"
              ).length
            }
          </span>
          <a
            href="# "
            onClick={() => this.filterIdeasByStatus("Completed")}
            className={
              this.state.filteredStatus === "Completed"
                ? "text-secondary"
                : "text-primary"
            }
          >
            Completed
          </a>
          <span className="badge badge-success badge-module  ml-1 mr-2">
            {
              this.state.receivedIdeas.filter((x) => x.status === "Completed")
                .length
            }
          </span>
          <a
            href="# "
            onClick={() => this.filterIdeasByStatus("Development in Process")}
            className={
              this.state.filteredStatus === "Development in Process"
                ? "text-secondary"
                : "text-primary"
            }
          >
            Development in Process
          </a>

          <span className="badge badge-primary badge-module  ml-1 mr-2">
            {
              this.state.receivedIdeas.filter(
                (x) => x.status === "Development in Process"
              ).length
            }
          </span>
        </div>
        {this.state.ideas.map((idea) => (
          <Idea
            key={idea.id}
            onVote={() => this.handleVote(idea)}
            idea={idea}
          ></Idea>
        ))}
      </div>
    );
  }
}

export default IdeasList;
